import commonService from './common-service';

class FormsService {
  async getForms(d1 = '', d2 = '',flag) {
    try {
      const response = await commonService.getFromServer('Forms', {d1,d2,flag});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getExprationPdf(params) {
    try {
      const response = await commonService.postToServer('Expiration',params);
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving Expiration pdf. Please contact administrator.');
      }
    } catch (e) {
      //throw new Error(e.message);
    }
  }
}

export default new FormsService();
